import { render, staticRenderFns } from "./gxPay.vue?vue&type=template&id=ba3f9a14&scoped=true"
import script from "./gxPay.vue?vue&type=script&lang=js"
export * from "./gxPay.vue?vue&type=script&lang=js"
import style0 from "./gxPay.vue?vue&type=style&index=0&id=ba3f9a14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3f9a14",
  null
  
)

export default component.exports